import { nzApiAxios } from 'src/utils/nz-axios/nz-axios';
import { Tabs } from '../selected-materials/selected-materials';

export const generalApiUrl = '/GeneralPage';

const GetServices = (data: { type: Tabs }) =>
  nzApiAxios.get(generalApiUrl + '/services', { params: data }).then((response) => response.data);

const GetVacancies = () => nzApiAxios.get(generalApiUrl + '/vacancies').then((response) => response.data);

const useGetNews = () => nzApiAxios.get(generalApiUrl + '/news').then((response) => response.data);

const GetContacts = (data: { type: Tabs }) =>
  nzApiAxios.get(generalApiUrl + '/contacts', { params: data }).then((response) => response.data);

const GetEvents = () => nzApiAxios.get(generalApiUrl + '/events').then((response) => response.data);

const GetMaterials = (data: { type: Tabs }) =>
  nzApiAxios.get(generalApiUrl + '/materials', { params: data }).then((response) => response.data);

const API = {
  getServices: GetServices,
  getVacancies: GetVacancies,
  getNews: useGetNews,
  getContacts: GetContacts,
  getEvents: GetEvents,
  getMaterials: GetMaterials
};

export default API;
